/** @format */

import React, { Suspense, lazy, useState } from "react";
import Tabs from "../../components/ui/Tabs";
import { formatDate } from "../../utils/utilityfunc";
import Loader from "../../components/ui/Loader";
import CoinsHistory from "../../components/incentive-system/user-details/user-details-tabs/CoinsHistory";

const WorkoutMapping = lazy(() => import("../workouts/WorkoutMapping"));
const MemberSubscription = lazy(() => import("./MemberSubscription"));
const DietDetails = lazy(() => import("./DietDetails"));

const MemberDetails = ({
  memberDetail,
  refetchMembersData,
  isLoadingMember,
  onClose,
}) => {
  const tabs = ["Details", "Subscription", "Coins", "Workout Mapping", "Diet"];
  const [activeTab, setActiveTab] = useState(tabs[0]);

  const getMemberDisease = (arr) => {
    try {
      if (Array.isArray(arr)) {
        const res = arr.reduce((acc, current) => {
          return acc.concat(current).concat(", ");
        }, "");
        return res;
      } else {
        return "N/A";
      }
    } catch (error) {
      console.log(error);
    }
  };

  const getHeight = (value) => {
    try {
      const s = `${value}`;
      if (s.includes(".")) {
        `${memberDetail?.height} FT`.replace("_ft", "");
      } else {
        return s?.replaceAll("_", " ");
      }
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <div>
      <div className="flex-k my-2">
        <Tabs
          activeTab={activeTab}
          setActiveTab={setActiveTab}
          tabs={tabs}
          type="secondary"
        />
      </div>

      {activeTab === tabs[0] ? (
        <div className="grid-k grid-col-2-k card-k m-2 my-4 fs-normal-text gap-1-k">
          <div className="grid-span-2-k">
            <h3 className="bold-text m-2">Member Details</h3>
          </div>
          <div className="flex-k gap-1-k">
            <span className="bold-text">Name: </span>
            <span>{memberDetail?.name}</span>
          </div>
          <div className="flex-k gap-1-k">
            <span className="bold-text">Email: </span>
            <span>{memberDetail?.email}</span>
          </div>
          <div className="flex-k gap-1-k">
            <span className="bold-text">Mobile: </span>
            <span>{memberDetail?.mobile}</span>
          </div>
          <div className="flex-k gap-1-k">
            <span className="bold-text">Gender: </span>
            <span>{memberDetail?.gender}</span>
          </div>
          <div className="flex-k gap-1-k">
            <span className="bold-text">Age: </span>
            <span>
              {memberDetail?.age ? `${memberDetail?.age} Years` : "N/A"}
            </span>
          </div>
          <div className="flex-k gap-1-k">
            <span className="uppercase-k bold-text">Height: </span>
            <span>{getHeight(memberDetail?.height)}</span>
          </div>
          <div className="flex-k gap-1-k">
            <span className="bold-text">Weight: </span>
            <span>
              {memberDetail?.weight
                ? `${memberDetail?.weight} Kgs`.replace("_kg", "")
                : null}
            </span>
          </div>
          <div className="flex-k gap-1-k">
            <span className="bold-text">Target Weight: </span>
            <span>
              {memberDetail?.target_weight
                ? `${memberDetail?.target_weight} Kgs`.replace("_kg", "")
                : null}
            </span>
          </div>
          <div className="flex-k gap-1-k">
            <span className="bold-text">Target Duration: </span>
            <span>
              {memberDetail?.target_duration
                ? `${memberDetail?.target_duration} Days`
                : "N/A"}
            </span>
          </div>
          <div className="flex-k gap-1-k">
            <span className="bold-text">Body Type: </span>
            <span className="capitalise-k">
              {memberDetail?.body_type ? memberDetail?.body_type : "N/A"}
            </span>
          </div>
          <div className="flex-k gap-1-k">
            <span className="bold-text">How Active: </span>
            <span>
              {memberDetail?.howactive ? memberDetail?.howactive : "N/A"}
            </span>
          </div>
          <div className="flex-k gap-1-k">
            <span className="bold-text">Is Drinking: </span>
            <span>{memberDetail?.is_drinking === "false" ? "No" : "Yes"}</span>
          </div>
          <div className="flex-k gap-1-k">
            <span className="bold-text">Is Smoking: </span>
            <span>{memberDetail?.is_smoking === "false" ? "No" : "Yes"}</span>
          </div>
          <div className="flex-k gap-1-k">
            <span className="bold-text">Last Login: </span>
            <span>
              {memberDetail?.last_login
                ? formatDate(
                    Number(memberDetail?.last_login) * 1000,
                    "DD, MMM YYYY | hh:mm A"
                  )
                : "N/A"}
            </span>
          </div>
          <div className="flex-k gap-1-k">
            <span className="bold-text">Existing Diseases: </span>
            <span>{getMemberDisease(memberDetail?.existing_disease)}</span>
          </div>
          <div className="flex-k gap-1-k">
            <span className="bold-text">Address: </span>
            <span>{memberDetail?.location || "N/A"}</span>
          </div>
        </div>
      ) : null}

      {activeTab === tabs[1] ? (
        <div>
          <Suspense fallback={<Loader />}>
            <MemberSubscription memberDetail={memberDetail} />
          </Suspense>
        </div>
      ) : null}
      {activeTab === tabs[2] ? (
        <div>
          <Suspense fallback={<Loader />}>
            <CoinsHistory row={memberDetail} />
          </Suspense>
        </div>
      ) : null}
      {activeTab === tabs[3] ? (
        <div>
          <Suspense fallback={<Loader />}>
            <WorkoutMapping memberDetail={memberDetail} />
          </Suspense>
        </div>
      ) : null}
      {activeTab === tabs[4] ? (
        <div>
          <Suspense fallback={<Loader />}>
            <DietDetails
              isLoadingMember={isLoadingMember}
              refetchMembersData={refetchMembersData}
              memberDetail={memberDetail}
              onClose={onClose}
            />
          </Suspense>
        </div>
      ) : null}
    </div>
  );
};

export default MemberDetails;
